import Reset from "components/Reset"
import styled from "styled-components"

export const Ul = styled(Reset.Ul)`
  display: flex;
  gap: 20px;
`

export const Li = styled(Reset.Li)``
